// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

html,
body {
  margin: 0;
  scroll-behavior: smooth;
  font-style: normal;
}

a {
  text-decoration: none;
}

select,
input,
textarea,
button {
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  color: var(--tg-theme-hint-color);
}

ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

ul,
ol,
li,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/reset.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;;;EAGE,mBAAA;AACF;;AAEA;;EAEE,SAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAGA;EACE,qBAAA;AAAF;;AAIA;;;;EAIE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iCAAA;AADF;;AAGA;;EAEE,SAAA;EACA,UAAA;EACA,gBAAA;AAAF;;AAGA;;;;;;;;;;EAUE,SAAA;AAAF","sourcesContent":["html {\n  box-sizing: border-box;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\nhtml,\nbody {\n  margin: 0;\n  scroll-behavior: smooth;\n  font-style: normal;\n}\n\n\na {\n  text-decoration: none;\n}\n\n\nselect,\ninput,\ntextarea,\nbutton{\n  background-color: transparent;\n  border: none;\n  outline: none;\n  padding: 0;\n  color: var(--tg-theme-hint-color);\n}\nul,\nli {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\nul,\nol,\nli,\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
